module.exports = __webpack_public_path__ + "images/emoji/sleeping.95eaa23ed45b7ce8e307.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sleeping.png
// module id = bVzl
// module chunks = 2